module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\n// var field\nvar ml, s, mailingList, mailingListAttributes, segment, segmentAttributes, currentMailingListID = 0;\nvar data = (model['resource-picker-data'] || {}).data || [];\nvar listFilter = {};\nvar disabled = model.disabled;\nvar additionalClasses = [];\nif(typeof(additionalCSSClass) !== 'undefined'){\nadditionalClasses.push(additionalCSSClass);\n}\nif(model.additionalCSSClass) {\nadditionalClasses.push(model.additionalCSSClass);\n}\nif(typeof(forceDisabled) === 'undefined'){\nforceDisabled = false;\n}\nif(model.forceDisabled){\nforceDisabled = true;\n}\n%>\n<select class=\"<%- additionalClasses.join(' ') %>\" data-field-type=\"select\" data-field-code=\"<%= model.fieldCode %>\"<%= (disabled || forceDisabled ? ' DISABLED' : '') %>>\n<option value=\"\">Alle Empfänger exkl. Importierte</option>\n<%\nfor(ml in data) {\nmailingList = data[ml] || {};\nmailingListAttributes = mailingList.attributes || {};\n// different mailing-list\nif (currentMailingListID != mailingListAttributes.mailingListID) {\nif (currentMailingListID != 0) {\n%>\n</optgroup>\n<%\t\t\t\t}\n%>\n<optgroup label=\"Mailingliste &quot;<%= mailingListAttributes.name %>&quot;\">\n<option value=\"<%= mailingListAttributes.mailingListID %>|0\"<%= listFilter.segmentID == 0 ? ' SELECTED' : '' %>>Alle Empfänger inkl. Importierte</option>\n<%\ncurrentMailingListID = mailingListAttributes.mailingListID;\n}\nfor(s in ((mailingList.children || {}).nl_segments || {}).data || []) {\nsegment = mailingList.children.nl_segments.data[s] || {};\nsegmentAttributes = segment.attributes || {};\n%>\n<option value=\"<%= currentMailingListID %>|<%= segmentAttributes.segmentID %>\"<%= listFilter.segmentID == segmentAttributes.segmentID ? ' SELECTED' : '' %>>Segment \"<%= segmentAttributes.name %>\"</option>\n<%\n}\n}\nif (currentMailingListID > 0) {\n%>\n</optgroup>\n<%\n}\n%>\n</select>"
  , __filename = "components/templates/newsletter/subscribers/fields/mailingListSegmentPicker.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
// var field
var ml, s, mailingList, mailingListAttributes, segment, segmentAttributes, currentMailingListID = 0;
var data = (model['resource-picker-data'] || {}).data || [];
var listFilter = {};
var disabled = model.disabled;
var additionalClasses = [];
if(typeof(additionalCSSClass) !== 'undefined'){
additionalClasses.push(additionalCSSClass);
}
if(model.additionalCSSClass) {
additionalClasses.push(model.additionalCSSClass);
}
if(typeof(forceDisabled) === 'undefined'){
forceDisabled = false;
}
if(model.forceDisabled){
forceDisabled = true;
}

    ; __line = 20
    ; __append("\n<select class=\"")
    ; __line = 21
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-type=\"select\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\"")
    ; __append(escapeFn( (disabled || forceDisabled ? ' DISABLED' : '') ))
    ; __append(">\n<option value=\"\">Alle Empfänger exkl. Importierte</option>\n")
    ; __line = 23
    ; 
for(ml in data) {
mailingList = data[ml] || {};
mailingListAttributes = mailingList.attributes || {};
// different mailing-list
if (currentMailingListID != mailingListAttributes.mailingListID) {
if (currentMailingListID != 0) {

    ; __line = 30
    ; __append("\n</optgroup>\n")
    ; __line = 32
    ; 				}

    ; __line = 33
    ; __append("\n<optgroup label=\"Mailingliste &quot;")
    ; __line = 34
    ; __append(escapeFn( mailingListAttributes.name ))
    ; __append("&quot;\">\n<option value=\"")
    ; __line = 35
    ; __append(escapeFn( mailingListAttributes.mailingListID ))
    ; __append("|0\"")
    ; __append(escapeFn( listFilter.segmentID == 0 ? ' SELECTED' : '' ))
    ; __append(">Alle Empfänger inkl. Importierte</option>\n")
    ; __line = 36
    ; 
currentMailingListID = mailingListAttributes.mailingListID;
}
for(s in ((mailingList.children || {}).nl_segments || {}).data || []) {
segment = mailingList.children.nl_segments.data[s] || {};
segmentAttributes = segment.attributes || {};

    ; __line = 42
    ; __append("\n<option value=\"")
    ; __line = 43
    ; __append(escapeFn( currentMailingListID ))
    ; __append("|")
    ; __append(escapeFn( segmentAttributes.segmentID ))
    ; __append("\"")
    ; __append(escapeFn( listFilter.segmentID == segmentAttributes.segmentID ? ' SELECTED' : '' ))
    ; __append(">Segment \"")
    ; __append(escapeFn( segmentAttributes.name ))
    ; __append("\"</option>\n")
    ; __line = 44
    ; 
}
}
if (currentMailingListID > 0) {

    ; __line = 48
    ; __append("\n</optgroup>\n")
    ; __line = 50
    ; 
}

    ; __line = 52
    ; __append("\n</select>")
    ; __line = 53
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/subscribers/fields/mailingListSegmentPicker.ejs

}